import * as Yup from 'yup'

export function ValidateFormComProduct(values) {
    return Yup.object().shape({
        name: Yup.string().required('This field is required'),
        message: Yup.string().required('This field is required')
    });
}

export function ValidateFormCountryProduct(values) {
    return Yup.object().shape({
        name: Yup.string().required('This field is required'),
        message: Yup.string().required('This field is required')
    });
}
